// Model.js
// -----------------------
// @module Case
define("NVT.MyEventAgenda.MyEventAgendaModule.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MyEventAgendaModule/SuiteScript2/MyEventAgendaModule.Service.ss"
            ),
            true
        )
});
});
